import React, {useContext, useEffect} from 'react';
import './App.css';
import Header from './components/header/Header';
import Sidebar from './components/sidebar/Sidebar';
import MainSection from './components/main/MainSection';
import Welcome from './pages/Welcome';
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ProductContext } from './ProductProvider';
import { RoutesLocal } from './routes';
import ForgotPassword from './pages/auth/ForgotPassword';
import SliderViewer from './pages/website/slider/SliderViewer';
import GalleryViewer from './pages/website/gallery/GalleryViewer';
import ActiveInfo from './pages/website/infodesk/ActiveInfo';
import MyProfile from './pages/profile/MyProfile';
import ClientsView from './pages/clients/ClientsView';
import AccountsExpiring from './pages/clients/AccountsExpiring';
import OrderDetails from './pages/clients/OrderDetails';
import SeasonalEmail from './pages/email/SeasonalEmail';
import NewRegistration from './pages/Registrations/NewRegistration';
import ManageRegistration from './pages/Registrations/ManageRegistration';
import StudentsDetails from './pages/StudentsInfo/StudentsDetails';
import AccountMgmt from './pages/StudentsInfo/AccountMgmt';
import AddCatalogue from './pages/catalogue/AddCatalogue';
import SearchCatalogue from './pages/catalogue/SearchCatalogue';
import AddSubscription from './pages/subscription/AddSubscription';
import SubscriptionSearch from './pages/subscription/SubscriptionSearch';
import PendingCatalogue from './pages/catalogueRequest/PendingCatalogue';
import SearchCatalogueRequest from './pages/catalogueRequest/SearchCatalogueRequest';
import NewCatalogue from './pages/catalogueRequest/NewCatalogue';

function App() {
  const { loggedUser, isSidebarOpen, validateLogin} = useContext(ProductContext);
  useEffect(()=>{
   // validateLogin();
  },[])

  return (
    <div className="App">
      {loggedUser.isAuthenticated && <Header /> }
      {loggedUser.isAuthenticated && <Sidebar />}
        <Routes>
          <Route path={RoutesLocal.Presentation.path} element={<Welcome />} />
          <Route path={RoutesLocal.DashboardOverview.path} element={<Welcome />} />
          <Route path={RoutesLocal.Signin.path} element={<Login />} />
          <Route path={RoutesLocal.ForgotPassword.path} element={<ForgotPassword />} />
          <Route path={RoutesLocal.SliderPath.path} element={<SliderViewer />} />
          <Route path={RoutesLocal.GalleryPath.path} element={<GalleryViewer />} />
          <Route path={RoutesLocal.FlashNews.path} element={<ActiveInfo />} />
          <Route path={RoutesLocal.MyProfile.path} element={<MyProfile />} />
          <Route path={RoutesLocal.NewRegistration.path} element={<NewRegistration />} />
          <Route path={RoutesLocal.ManageRegistration.path} element={<ManageRegistration />} />
          <Route path={RoutesLocal.MemberSearch.path} element={<StudentsDetails />} />
          <Route path={RoutesLocal.memberAccounts.path} element={<AccountMgmt />} />
          <Route path={RoutesLocal.NewCatalogue.path} element={<AddCatalogue />} />
          <Route path={RoutesLocal.SearchCatalogue.path} element={<SearchCatalogue />} />
          <Route path={RoutesLocal.AddSubscription.path} element={<AddSubscription />} />
          <Route path={RoutesLocal.SearchSubscription.path} element={<SubscriptionSearch />} />
          <Route path={RoutesLocal.PendingRequestCatalogue.path} element={<PendingCatalogue />} />
          <Route path={RoutesLocal.SearchRequestCatalogue.path} element={<SearchCatalogueRequest />} />
          <Route path={RoutesLocal.NewRequestCatalogue.path} element={<NewCatalogue />} />

          <Route path="*" element={<Navigate to="/" replace />}/>
      </Routes>

    </div>
  );
}

export default App;
